import { useCallback, useMemo } from 'react'
import { Inbox } from 'lucide-react'
import { PageHeader } from '@/shell/AppShell'
import { DataTable } from '@/components/DataTable'
import type { AdminColumn } from '@/components/DataTable/types'
import { PERMISSIONS } from '@/lib/permissions'
import { fetchUpdates, DT_STR as S, type UpdateRow } from './devtoolsApi'

/**
 * A27.04 — Просмотр апдейтов. Raw Telegram-style Update objects seen by the
 * platform (update_id/type/chat + JSON payload). Dormant until `/admin/devtools/
 * updates` ships — fetcher fail-soft. Placeholder permission USERS_VIEW.
 */
export function UpdateViewerScreen() {
  const columns = useMemo<AdminColumn<UpdateRow>[]>(
    () => [
      { key: 'update_id', header: S.updateId, type: 'number' },
      { key: 'type', header: S.type, type: 'text' },
      { key: 'chat', header: S.chat, type: 'text' },
      { key: 'received_at', header: S.received, type: 'text' },
      { key: 'payload', header: S.payload, type: 'json' },
    ],
    [],
  )
  const fetcher = useCallback(fetchUpdates, [])
  return (
    <>
      <PageHeader title={S.updateViewer} screenId="A27.04" />
      <DataTable<UpdateRow>
        screenId="A27.04"
        permission={PERMISSIONS.USERS_VIEW}
        columns={columns}
        fetcher={fetcher}
        rowId={(r) => String(r.id)}
        exportable
        emptyState={{ icon: <Inbox size={28} strokeWidth={1.5} /> }}
      />
    </>
  )
}
